// const BASE_URL = "http://localhost:5000/api";
const BASE_URL = "https://apisbtc.wildduckfishingroom.com/api";

export default BASE_URL;